import { intersection } from "es-toolkit";

import type { InteractModuleListItem } from "@skilitics/nautilus-endpoint-definition";

export const createTagsFilter = (tags: string[]) => (modules: InteractModuleListItem[]) =>
  modules.filter((module) => intersection(module.tags, tags).length);
